import { render, staticRenderFns } from "./chat-sidebar-group.vue?vue&type=template&id=f4f78798&scoped=true&"
import script from "./chat-sidebar-group.vue?vue&type=script&lang=js&"
export * from "./chat-sidebar-group.vue?vue&type=script&lang=js&"
import style0 from "./chat-sidebar-group.vue?vue&type=style&index=0&id=f4f78798&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f78798",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4f78798')) {
      api.createRecord('f4f78798', component.options)
    } else {
      api.reload('f4f78798', component.options)
    }
    module.hot.accept("./chat-sidebar-group.vue?vue&type=template&id=f4f78798&scoped=true&", function () {
      api.rerender('f4f78798', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/chat-sidebar-group/chat-sidebar-group.vue"
export default component.exports